const scaleCorrectors = {};

export { scaleCorrectors };
